import { FC } from 'react'
import cx from 'classnames'
import { createUseStyles } from 'react-jss'
import { addDefaultProps, addDisplayName, addProps, flowMax } from 'ad-hok'

import Icon, { IconName } from './Icon'
import { BODY_MEDIUM_STYLE } from './styles'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 16,
    paddingRight: 24,
    height: 64,
    borderRadius: 2,
    backgroundColor: 'rgba(203, 166, 122, 0.08)',
  },
  filled: {
    background: '#CBA67A',
  },
  text: {
    ...BODY_MEDIUM_STYLE,
    textAlign: 'left',
    marginLeft: 16,
    marginRight: 'auto',
    color: 'rgba(54, 52, 50, 0.8)',
  },
  textFilled: {
    color: 'white',
  },
  icon: {
    color: '#CBA67A',
  },
  iconDisabled: {
    color: 'rgba(203, 166, 122, 0.24)',
  },
  iconFilled: {
    color: 'white',
  },
})

interface Props {
  icon: IconName
  rightIcon?: IconName
  text: string
  onClick: () => void
  disabled?: boolean
  filled?: boolean
  className?: string
  textClassName?: string
}

export const NextActionButton: FC<Props> = flowMax(
  addDisplayName('NextActionButton'),
  addDefaultProps({
    rightIcon: 'chevron-right',
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({
    icon,
    rightIcon,
    text,
    onClick,
    disabled,
    filled,
    classes,
    className,
    textClassName,
  }) => (
    <button
      className={cx(classes.container, filled && classes.filled, className)}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon
        name={icon}
        className={cx(
          classes.icon,
          disabled && classes.iconDisabled,
          filled && classes.iconFilled
        )}
      />
      <span
        className={cx(
          classes.text,
          filled && classes.textFilled,
          textClassName
        )}
      >
        {text}
      </span>
      <Icon
        name={rightIcon}
        className={cx(
          classes.icon,
          disabled && classes.iconDisabled,
          filled && classes.iconFilled
        )}
      />
    </button>
  )
)
